var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-80"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.59,
    y: 320.17,
    width: 175.5,
    height: 76.5,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-80"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.57,
    y: 320.17,
    width: 162.25,
    height: 91.5,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.56,145S399.23,99.3,345.51,92.53s-91.24,26.24-130.77,43.17c-20.71,8.87-44.35,5.43-66.33,9.72C78.13,159.14,51.65,245.1,80.93,294c25.34,42.32,69.94,64.33,137.86,69.41s115.56,11,176.39-30.47S451.94,205.11,423.56,145Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.56,145S399.23,99.3,345.51,92.53s-91.24,26.24-130.77,43.17c-20.71,8.87-44.35,5.43-66.33,9.72C78.13,159.14,51.65,245.1,80.93,294c25.34,42.32,69.94,64.33,137.86,69.41s115.56,11,176.39-30.47S451.94,205.11,423.56,145Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Background--inject-80"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.2,
    cy: 404.18,
    rx: 199.3,
    ry: 19.77,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.2,
    cy: 404.18,
    rx: 199.3,
    ry: 19.77,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.67,
    y: 301.37,
    width: 372,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.21,260a7.72,7.72,0,0,0,2.24.24s-.34-1-.37-1.1c-.35-.72-1.45-1.92-2.34-1.8a1.06,1.06,0,0,0-.86,1.34A2.23,2.23,0,0,0,331.21,260Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,254.57c-.9-.1-2,1.13-2.29,1.86,0,.07-.36,1.11-.34,1.11h0l-.54.64c-.36.43-.75.92-1.14,1.48a19.8,19.8,0,0,0-1.18,1.88,14.15,14.15,0,0,0-1,2.26v0c0-.27,0-1,0-1.06-.11-.8-.78-2.29-1.66-2.45a1.06,1.06,0,0,0-1.23,1,2.18,2.18,0,0,0,.85,1.67,7.38,7.38,0,0,0,2,.93,17.53,17.53,0,0,0-.6,2.45c-.08.48-.16,1-.22,1.46,0-.23,0-.43,0-.46-.11-.8-.78-2.28-1.66-2.44a1.08,1.08,0,0,0-1.24,1,2.24,2.24,0,0,0,.86,1.67,7.43,7.43,0,0,0,2,.91c0,.18-.05.37-.07.56-.11.91-.21,1.81-.34,2.69,0,.32-.1.62-.16.93a3.17,3.17,0,0,0,0-.4c-.1-.8-.77-2.29-1.66-2.45a1.06,1.06,0,0,0-1.23,1,2.23,2.23,0,0,0,.86,1.67,6.72,6.72,0,0,0,1.9.89c-.06.31-.13.62-.21.92a5.87,5.87,0,0,1-.16.6c-.07.2-.13.4-.2.6-.13.37-.27.76-.41,1.12l-.29.72c.05-.31.13-.91.13-1a4,4,0,0,0-.55-2,1,1,0,0,0,0-.24,1.06,1.06,0,0,0-1.3-.9c-.87.23-1.43,1.76-1.47,2.56,0,.05,0,.57.06.89-.05-.18-.09-.37-.14-.56-.09-.39-.19-.77-.3-1.18l-.18-.6c-.06-.2-.14-.4-.21-.61-.17-.47-.37-.94-.58-1.41a6.88,6.88,0,0,0,2-.75,2.25,2.25,0,0,0,1-1.6,1.07,1.07,0,0,0-1.15-1.1c-.9.1-1.68,1.53-1.84,2.32,0,.05-.06.63-.09.94-.13-.28-.25-.56-.39-.84-.4-.8-.83-1.61-1.26-2.41l-.39-.74a7.62,7.62,0,0,0,2.09-.77,2.25,2.25,0,0,0,1-1.61,1.07,1.07,0,0,0-1.15-1.09c-.9.1-1.68,1.53-1.84,2.32,0,.06-.09.89-.1,1.1-.28-.54-.56-1.09-.81-1.63a19.42,19.42,0,0,1-.88-2.28,7.44,7.44,0,0,0,2.1-.77,2.25,2.25,0,0,0,1-1.61,1.07,1.07,0,0,0-1.16-1.09c-.89.1-1.67,1.53-1.83,2.32,0,.06-.1,1-.1,1.12a.78.78,0,0,0-.05-.14,13.28,13.28,0,0,1-.45-2.4c-.05-.45-.08-.88-.09-1.3a6.94,6.94,0,0,0,2.12-.53,2.26,2.26,0,0,0,1.15-1.48,1.08,1.08,0,0,0-1-1.22c-.9,0-1.83,1.34-2.08,2.1,0,0-.1.48-.16.8,0-.19,0-.38,0-.56,0-.69,0-1.31.08-1.86,0-.32.06-.6.09-.87a7.06,7.06,0,0,0,1.63-1.44,2.22,2.22,0,0,0,.33-1.85,1.06,1.06,0,0,0-1.47-.6c-.8.41-1,2-.88,2.82,0,.07.32,1.12.33,1.12l0,0c0,.26-.07.53-.1.83-.06.55-.12,1.18-.13,1.86a18.73,18.73,0,0,0,.05,2.22,13.67,13.67,0,0,0,.41,2.44v0c-.14-.23-.56-.84-.6-.88-.53-.61-1.9-1.48-2.73-1.12a1.06,1.06,0,0,0-.48,1.51,2.23,2.23,0,0,0,1.64.92,7.51,7.51,0,0,0,2.2-.34,17.36,17.36,0,0,0,.86,2.37c.19.45.4.9.62,1.34-.13-.19-.25-.35-.27-.37-.53-.61-1.9-1.48-2.73-1.13a1.07,1.07,0,0,0-.48,1.52,2.26,2.26,0,0,0,1.64.92,7.07,7.07,0,0,0,2.14-.33c.08.17.16.34.25.51.41.82.82,1.63,1.2,2.44.13.28.26.57.38.85l-.23-.33c-.53-.6-1.91-1.47-2.74-1.12a1.07,1.07,0,0,0-.47,1.52,2.24,2.24,0,0,0,1.64.92,7.17,7.17,0,0,0,2.08-.31c.11.29.23.59.33.88s.14.39.19.59l.17.61c.09.38.19.78.27,1.16s.11.51.16.76l-.42-.88c-.43-.68-1.66-1.75-2.54-1.52a1.05,1.05,0,0,0-.69,1.42,2.19,2.19,0,0,0,1.47,1.16,7.33,7.33,0,0,0,2.22,0c.08.42.16.82.22,1.21.24,1.34.39,2.46.48,3.25,0,.14,0,.27,0,.38H337l1,19.35h4.62l1-19.35h-2.53l.06-.11c.35-.72.83-1.76,1.35-3l.5-1.27a7.78,7.78,0,0,0,2.21.17,2.27,2.27,0,0,0,1.56-1,1.06,1.06,0,0,0-.59-1.47c-.86-.29-2.16.68-2.64,1.33,0,0-.29.49-.45.77l.21-.55c.13-.37.26-.74.39-1.15l.18-.59a6.45,6.45,0,0,0,.16-.63c.12-.49.21-1,.3-1.49a7,7,0,0,0,2.09.48,2.21,2.21,0,0,0,1.7-.8,1.07,1.07,0,0,0-.36-1.55c-.8-.41-2.24.35-2.81.92,0,0-.4.49-.59.74.05-.3.09-.61.13-.92.11-.89.2-1.8.29-2.7,0-.28.05-.56.08-.84a7.16,7.16,0,0,0,2.17.51,2.23,2.23,0,0,0,1.7-.79,1.07,1.07,0,0,0-.36-1.55c-.8-.42-2.24.35-2.81.91,0,0-.57.7-.69.87.06-.61.13-1.21.23-1.81a16.47,16.47,0,0,1,.52-2.38,7.44,7.44,0,0,0,2.17.51,2.22,2.22,0,0,0,1.7-.79,1.07,1.07,0,0,0-.36-1.55c-.8-.42-2.23.35-2.81.91,0,.05-.6.75-.7.89a1,1,0,0,0,0-.14,14.45,14.45,0,0,1,.94-2.26c.21-.4.43-.77.65-1.13a7.27,7.27,0,0,0,2.06.73,2.24,2.24,0,0,0,1.78-.61,1.08,1.08,0,0,0-.19-1.58c-.75-.49-2.26.11-2.89.61,0,0-.36.34-.58.57l.3-.47c.38-.57.76-1.07,1.1-1.51l.55-.67a7,7,0,0,0,2.15-.3,2.24,2.24,0,0,0,1.3-1.36A1.06,1.06,0,0,0,352,254.57ZM342,278.67c-.55,1.24-1,2.26-1.4,3l-.2.38h-.06q0-.19-.06-.45c-.11-.8-.28-1.93-.55-3.28-.08-.42-.18-.88-.29-1.34a12,12,0,0,0,1.24-.58,7.83,7.83,0,0,0,1.8,1.16C342.34,277.92,342.18,278.31,342,278.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.23,260.31s.29-1.06.3-1.13c.11-.79-.14-2.4-1-2.79a1.06,1.06,0,0,0-1.45.64,2.22,2.22,0,0,0,.39,1.84A8,8,0,0,0,347.23,260.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59,262a7.26,7.26,0,0,0,2.12.24s-.33-1-.35-1.05c-.33-.69-1.38-1.83-2.23-1.71a1,1,0,0,0-.81,1.27A2.1,2.1,0,0,0,116.59,262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.31,256.87c-.85-.09-1.87,1.07-2.18,1.77,0,.07-.34,1.06-.32,1.06h0c-.17.18-.34.38-.52.6-.33.41-.71.88-1.08,1.41s-.76,1.13-1.12,1.78a14.22,14.22,0,0,0-1,2.16v0c0-.25,0-.95,0-1-.1-.76-.74-2.17-1.58-2.32a1,1,0,0,0-1.17,1,2.13,2.13,0,0,0,.81,1.59,6.94,6.94,0,0,0,1.93.88,17.61,17.61,0,0,0-.57,2.33c-.08.46-.15.93-.21,1.39,0-.22,0-.41,0-.44-.1-.76-.74-2.17-1.58-2.32a1,1,0,0,0-1.17.95,2.13,2.13,0,0,0,.81,1.59,6.58,6.58,0,0,0,1.87.86c0,.18-.05.36-.07.54-.1.86-.2,1.72-.32,2.56l-.15.88c0-.2,0-.36,0-.38-.1-.76-.74-2.17-1.58-2.33a1,1,0,0,0-1.17,1,2.12,2.12,0,0,0,.81,1.58,6.79,6.79,0,0,0,1.81.85c-.06.29-.12.59-.2.87a5.32,5.32,0,0,1-.16.57l-.18.57c-.13.35-.26.72-.39,1.06s-.19.47-.28.69c.05-.29.13-.87.13-.92a3.93,3.93,0,0,0-.53-1.91,1.77,1.77,0,0,0,0-.23,1,1,0,0,0-1.24-.86c-.83.22-1.36,1.68-1.4,2.44,0,.05,0,.54,0,.85l-.12-.54c-.09-.37-.19-.73-.29-1.12-.06-.19-.11-.38-.17-.57s-.14-.39-.2-.58c-.17-.45-.35-.9-.55-1.34A6.82,6.82,0,0,0,125,273a2.15,2.15,0,0,0,.93-1.52,1,1,0,0,0-1.1-1c-.85.09-1.59,1.45-1.74,2.2,0,.05-.07.6-.09.9-.12-.26-.24-.53-.37-.8-.38-.77-.79-1.53-1.2-2.3l-.36-.7a7.25,7.25,0,0,0,2-.73,2.15,2.15,0,0,0,.93-1.53,1,1,0,0,0-1.1-1c-.85.1-1.59,1.46-1.75,2.21,0,.05-.08.85-.09,1.05-.27-.52-.53-1-.77-1.56a17.4,17.4,0,0,1-.83-2.16,7.18,7.18,0,0,0,2-.74,2.08,2.08,0,0,0,.93-1.52,1,1,0,0,0-1.1-1c-.85.09-1.59,1.45-1.74,2.2,0,.06-.09.91-.09,1.07a.69.69,0,0,1,0-.13,12.84,12.84,0,0,1-.43-2.28c0-.43-.07-.84-.09-1.24a6.63,6.63,0,0,0,2-.5,2.12,2.12,0,0,0,1.09-1.42,1,1,0,0,0-1-1.15c-.86,0-1.75,1.27-2,2,0,0-.1.45-.16.76,0-.18,0-.37,0-.54,0-.65,0-1.24.08-1.77,0-.3.06-.57.09-.82a6.62,6.62,0,0,0,1.54-1.37,2.09,2.09,0,0,0,.32-1.76,1,1,0,0,0-1.39-.57c-.77.39-1,1.93-.84,2.68,0,.07.3,1.07.31,1.06h0c0,.24-.07.5-.1.79,0,.52-.11,1.12-.12,1.77a16.74,16.74,0,0,0,0,2.1,12.23,12.23,0,0,0,.39,2.32v0l-.57-.83c-.5-.58-1.81-1.41-2.6-1.07a1,1,0,0,0-.45,1.44,2.11,2.11,0,0,0,1.55.87,6.89,6.89,0,0,0,2.09-.32,20.36,20.36,0,0,0,.82,2.25c.18.43.38.86.59,1.28l-.25-.36c-.5-.58-1.81-1.4-2.6-1.07a1,1,0,0,0-.45,1.44,2.12,2.12,0,0,0,1.55.88,7,7,0,0,0,2-.31c.09.16.16.32.24.48.39.78.79,1.55,1.15,2.32l.36.81-.22-.31c-.5-.58-1.81-1.41-2.6-1.07a1,1,0,0,0-.45,1.44,2.12,2.12,0,0,0,1.55.88,6.49,6.49,0,0,0,2-.3c.11.28.22.56.32.84s.13.37.18.57.11.38.16.57c.09.36.18.74.26,1.1l.15.73c-.12-.27-.38-.79-.4-.84-.41-.64-1.58-1.66-2.41-1.45a1,1,0,0,0-.67,1.36,2.13,2.13,0,0,0,1.41,1.1,6.87,6.87,0,0,0,2.1,0c.08.39.16.78.22,1.15.23,1.27.36,2.34.45,3.09,0,.14,0,.25,0,.37h-2.58l.94,18.39h4.4L128.4,283H126l0-.11c.33-.69.79-1.68,1.28-2.89.16-.38.32-.79.48-1.22a6.71,6.71,0,0,0,2.1.17,2.11,2.11,0,0,0,1.48-1,1,1,0,0,0-.56-1.4c-.81-.27-2.05.65-2.51,1.27l-.42.73c.06-.17.13-.34.19-.52.13-.35.25-.71.38-1.09.06-.19.11-.38.17-.57s.1-.39.15-.59c.11-.47.2-.94.28-1.42a6.81,6.81,0,0,0,2,.45,2.15,2.15,0,0,0,1.62-.75,1,1,0,0,0-.34-1.48c-.76-.39-2.13.34-2.67.88,0,0-.38.46-.57.7.05-.29.09-.58.13-.87.11-.85.19-1.72.27-2.58,0-.26.05-.52.08-.79a7,7,0,0,0,2.06.48,2.15,2.15,0,0,0,1.62-.75,1,1,0,0,0-.34-1.47c-.77-.4-2.13.33-2.68.87,0,0-.53.66-.65.82.06-.58.12-1.15.21-1.72a17.73,17.73,0,0,1,.5-2.26,7,7,0,0,0,2.07.48,2.13,2.13,0,0,0,1.61-.75,1,1,0,0,0-.34-1.48c-.76-.39-2.13.34-2.67.88,0,0-.58.71-.66.84l0-.14a13.34,13.34,0,0,1,.9-2.14c.19-.38.4-.74.61-1.08a6.41,6.41,0,0,0,2,.69,2.08,2.08,0,0,0,1.69-.57,1,1,0,0,0-.18-1.5c-.71-.48-2.15.09-2.75.57l-.55.55c.1-.15.19-.31.29-.45.36-.54.72-1,1-1.43.19-.24.36-.45.53-.64a6.87,6.87,0,0,0,2-.29,2.16,2.16,0,0,0,1.24-1.29A1,1,0,0,0,136.31,256.87Zm-9.44,22.91c-.52,1.19-1,2.16-1.33,2.83-.07.14-.14.26-.19.37h-.06c0-.14,0-.28-.06-.44-.1-.76-.26-1.83-.52-3.11-.08-.41-.17-.84-.27-1.28a11,11,0,0,0,1.17-.55,7.71,7.71,0,0,0,1.71,1.1Q127.1,279.27,126.87,279.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.82,262.32s.27-1,.28-1.06c.1-.76-.14-2.29-.91-2.66a1,1,0,0,0-1.38.61,2.12,2.12,0,0,0,.36,1.75A7.17,7.17,0,0,0,131.82,262.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355,
    y1: 303.37,
    x2: 355,
    y2: 115.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187,
    y1: 303.37,
    x2: 187,
    y2: 116.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.75,
    y1: 211.16,
    x2: 428.24,
    y2: 211.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.36,127.59h6.85a3.32,3.32,0,0,1,3.32,3.32v7.59a0,0,0,0,1,0,0H129a0,0,0,0,1,0,0v-7.59A3.32,3.32,0,0,1,132.36,127.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.89,148.56a6.28,6.28,0,1,1-6.28-6.28A6.28,6.28,0,0,1,141.89,148.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.49 148.85 109.08 148.85 129.11 137.94 142.41 137.94 162.49 148.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.65,
    y: 107.26,
    width: 2.26,
    height: 21.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.82,127.59h6.84a3.32,3.32,0,0,1,3.32,3.32v7.59a0,0,0,0,1,0,0H385.5a0,0,0,0,1,0,0v-7.59A3.32,3.32,0,0,1,388.82,127.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.07,
    cy: 148.56,
    r: 6.28,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.95 148.85 365.54 148.85 385.57 137.94 398.87 137.94 418.95 148.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.11,
    y: 107.26,
    width: 2.26,
    height: 21.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.04,
    y1: 176.66,
    x2: 231.7,
    y2: 179.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.3,
    y1: 131.51,
    x2: 241.88,
    y2: 173.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.2,
    y1: 134.32,
    x2: 264.18,
    y2: 167.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.79,
    y1: 119.78,
    x2: 325.47,
    y2: 129.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.34,294.34s-1.74,11.53-.52,17.64,5.76,36,7,48.21,7.16,30.73,7.51,31.61-.52,3.31-.52,4.36.35,3.5.35,3.5-5.07,3.31-7.69,4.89-1.39,2.27,1.05,2.61,37,0,37,0,.87-.17-.18-1.74-8.21-6.46-8.21-6.46a25,25,0,0,1-.17-3.5c0-2.44-2.1-6.81-2.1-6.81s3.85-27.94,3-35.28-1.22-14.84.18-21.48-.7-36.15-.35-37.55a5.26,5.26,0,0,0-.35-3s-11,4.36-20.26,5.06A36.13,36.13,0,0,1,257.34,294.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.35,405.42c-1.05-1.57-8.21-6.46-8.21-6.46s0-.13,0-.35A38.57,38.57,0,0,0,281.28,405s.57-.76-2.65-3.41a10.32,10.32,0,0,0-7.49-2s-5.07,3.31-7.69,4.89-1.39,2.27,1.05,2.61,37,0,37,0S302.4,407,301.35,405.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.69,405.63s6.43.47,9.09-.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.45,246.13s-5,27-6.29,31.06-.79,13.5,3,12.4,5-6.75,5.33-8.32.63-29,.63-33.74S255.45,246.13,255.45,246.13Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.66,235.72s-12.9,3.79-15,4.23-3.14,3.58-3.25,6.18.33,29.15.22,37.07-1.19,10.62,2.38,13.54,13.66,3.47,22.87,2.82,13.34-3.47,13.34-7.58-.65-23.63-.65-23.63,1-11.38,3.25-16.26,3.57-6.4,1.84-8.13-12.47-7.91-16.69-9.11A13,13,0,0,0,273.66,235.72Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.17,243.31l1.19,7.59,8.67-5.1-3.79-6.18S271.93,241.25,271.17,243.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.34,231.79a15.56,15.56,0,0,0-4,5.41c-1.21,3.07-3.73,7.92-2.7,8.19s4.1-2.32,4.75-2.32,1.95,3.16,2.33,3.26a27.4,27.4,0,0,0,3.91-1.4s.56,4,1.77,4.1,5.31-6.15,6.06-10.81-1.68-5.4-2.15-5.5S278.35,230.21,274.34,231.79Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.69,216.6s-.18-4.28-.18-6.89.37-4,1.95-4.57,2.05,1.87,2,3.17S273.69,216.6,273.69,216.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.69,215.58s-.09-3.17-1.21-1.49-.74,5.59,0,5.22S273.69,215.58,273.69,215.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.88,231.61s-.28,7.54-.47,10.52.84,4.66,2.61,4,6.06-6.34,7.36-8.57a27.67,27.67,0,0,0,2.14-4.85S279.1,234.68,273.88,231.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,207.38s-3.35,11.09-4.28,15.09-.47,7.37,1.21,10a8.05,8.05,0,0,0,7.36,3.64c3-.1,6.71-.84,8.94-5.5a70.24,70.24,0,0,0,3.08-7.92c.46-.93,2.14-5.78,3.07-8.85s-.91-6.77-4.47-8.85C289.83,204.32,282.55,199.72,276,207.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,221.64s2.33-1.87,3-.47-.56,3.91-2.14,4.75a2.86,2.86,0,0,1-2.61.28S292,222.66,293,221.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.05,203.47l-1-1.12s-.09-.75-3.08-1.86-6.43-.94-7.64-2.43-2.61-1.86-6.15-1.3-5,4.19-5,7.17,6.43,7.18,10.9,7.83,8.86-.75,7.92.09-3.63,3.82-2.7,4.85,1.49,1.67,1.49,2.89c0,.83-.17,2.75-.13,3.91-.36.73-1.32,2.68-1.54,3s-2.89-1.86-4.48-2.7a5.9,5.9,0,0,0-2.42-.84s-.09,1.4-.74,1.58-2.89.19-3.55-.46a2.66,2.66,0,0,1-.46-2,9.05,9.05,0,0,0-6.06,2.63,11.71,11.71,0,0,0,1.59,7.71,8.05,8.05,0,0,0,7.36,3.64c3-.1,6.71-.84,8.94-5.5A47,47,0,0,0,292,223.5a5.71,5.71,0,0,0,.69-1.4,23.19,23.19,0,0,1,3.35-5.4,14.59,14.59,0,0,0,2.8-8.57A5.08,5.08,0,0,0,296.05,203.47Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,204s-6-2.25-7,2,9,5.5,17.25,4",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.5,215s1.75.5,5.75-.75",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.56,215.58l-.37,2.14s-2.42,5.41-1.77,6.06,4.1,1.4,4.38.28a7.64,7.64,0,0,0,.28-1.59l-1.12-.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.48,216.42s3.44-.84,4.28,2.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.82,214.65a2.58,2.58,0,0,0-3.08-.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.87,219.67c-.08.56-.41,1-.74.93s-.54-.54-.46-1.1.4-1,.74-.93S284.94,219.11,284.87,219.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.09,217.34c-.08.56-.41,1-.74.93s-.54-.53-.46-1.1.4-1,.74-.93S277.16,216.78,277.09,217.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.94,226.57c-3.9,4.63-7,.81-7.27-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.36,250.9s-4.55,18.1-5.42,26.77a138.4,138.4,0,0,0-.76,14.74l2.28,4,3.36-4s-.11-19.29-.11-25.47S272.36,250.9,272.36,250.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.84,254.35s-2.79,6.29-1.74,9.43,9.95,16.24,10.82,16.77,7.69,2.09,8.56-1.92-6.46-27.77-8.73-31.26-4-3.15-4.89-2.45",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.74 267.45 270.79 295.39 292.1 294.35 291.57 266.93 269.74 267.45",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.29,273.74s-5.41.52-8.56,2.27-15.37,4.36-15.37,4.36l.7,6.81a65.49,65.49,0,0,0,16.59,0c7.86-1.22,12.4-.87,12.75-3.14s-2.62-10.83-2.62-10.83",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.91,
    y1: 279.67,
    x2: 288.25,
    y2: 287.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,281.07,278,276.36s-4-2.1-4.89-2.1a51,51,0,0,0-5.41.87c-.7.18-.35,1.05.87,1.58a7,7,0,0,0,2.44.52s-5.58,1.22-5.58,2.62,2.44,2.09,2.44,2.09-.7,3.32.87,4.55,3.15,1.74,5.94,1,9.43-.35,9.43-.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.49,278.13s-4.08-4.86-5.33-8.63-4.08-11-4.08-11l-4.55-.16s.47,14.12,3,22.13,5.8,12.08,7.53,11.3,4.24-4.55,4.24-4.55",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.79,240.79a5.54,5.54,0,0,0-2.2,3.61c-.32,1.25-.94,1.72-3,1.57a2.75,2.75,0,0,0-2.05.51,5.06,5.06,0,0,1-.14-1c0-1.12,1.91-3.58,2.78-4.29s2.14-1.75,2-2.7-3.73,1.11-4.76,1.83-1.59,3.65-1.59,3.65a10.72,10.72,0,0,0-.14,5.54c-.11.24-.21.47-.32.74-1.41,3.45.16,8.16.16,8.16l4.55.16s-.47-2.35.31-3.3a23.11,23.11,0,0,1,2.67-3.45c1.25-1.1,1.88-4.39,1.88-5.18a14,14,0,0,1,1.1-4.23C251.67,240.94,251.2,239.85,249.79,240.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.64,246.93s.56-2.93,1.59-3.65,4.61-2.78,4.76-1.82-1.11,2-2,2.69-2.78,3.18-2.78,4.29a9.23,9.23,0,0,0,.64,2.7s-1,1.83-1.75,2.06S238.77,249.87,239.64,246.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.8,248.68s.56-2.94,1.59-3.65,4.6-2.78,4.76-1.83-1.11,2-2,2.7-2.78,3.18-2.78,4.29a9.23,9.23,0,0,0,.64,2.7s-1,1.82-1.75,2.06S238.93,251.62,239.8,248.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,256.54s-1.27-4.37-1.11-6.11.79-3.26,1.67-3.34,4.6-1.43,4.6-.4-3.41,2.15-3.41,2.15,2.14,2.78,2.06,4.2a15.6,15.6,0,0,1-.55,3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.17 310.76 272.1 313.64 281.27 403.76",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk-1--inject-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.56,266.78s3.1,7.81,3.24,10.61-.58,2.35.59,6,4.57,12.37,6.49,19.44a66.87,66.87,0,0,1,2.21,17.68H135.28s1.62-4.42-2.8-16.79S126.3,284,126.3,280.48s-1.92-7.07-2.66-11.05,1.62-3.54,1.62-3.54l17.83.15S144.27,265.89,144.56,266.78Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.52,267.66c.17-2.06,1.74-1.77,1.74-1.77l17.83.15s1.18-.15,1.47.74c0,0,3.1,7.81,3.24,10.61a12.67,12.67,0,0,1-.06,2.21l-.38.58s-.59,5.16-7.66,5.46-11-2.95-12.52-6.05-2.06-8.1-3.24-11C123.82,268.25,123.67,268,123.52,267.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.3,280.48c0-3.54-1.92-7.07-2.66-11.05-.51-2.75.46-3.39,1.11-3.52.25.09,1.16.62,2.28,4.11,1.33,4.12.59,9.57,1.33,14s4.42,14.15,7.07,21.37c2.18,5.94,2.67,11.68,1.78,15.17h-1.93s1.62-4.42-2.8-16.79S126.3,284,126.3,280.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.43,320.29H217.69a1.29,1.29,0,0,1,0-2.57h17.74a3,3,0,0,0,2.93-3.85l-6.3-22.55a1.28,1.28,0,0,1,2.47-.69l6.3,22.55a5.61,5.61,0,0,1-5.4,7.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.09,
    y: 261.23,
    width: 4.05,
    height: 52.31,
    transform: "translate(35.82 -25.11) rotate(6.84)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.23,261.65A78.36,78.36,0,0,1,227,313.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.59,
    y: 320.17,
    width: 175.5,
    height: 76.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-80)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.59,
    y: 320.17,
    width: 175.5,
    height: 76.5,
    style: {
      fill: "#fff",
      opacity: 0.72
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 71.59,
    y: 320.17,
    width: 175.5,
    height: 76.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.61,
    y: 322.34,
    width: 175.52,
    height: 2.54,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.09,
    y: 318.67,
    width: 181.5,
    height: 4,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.64,260.08l-19.72.17s-1.3-.17-1.63.81c0,0-3.42,8.64-3.59,11.74s.66,2.6-.65,6.68S392,293.17,389.88,301c-2.85,10.52-3.59,21.68-3.77,32.53,0,1.74-1.07,16.73,1.64,16.73,2.25,0,23,2.75,23.25-1.25,1-15.94-1.88-31.52,3.66-47,2.15-6,4.61-12.38,6.44-18.68s2.14-12.85,3.33-19.3C425.25,259.59,422.64,260.08,422.64,260.08Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.57,262c-.19-2.27-1.93-1.95-1.93-1.95l-19.72.17s-1.3-.17-1.63.81c0,0-3.42,8.64-3.59,11.74a15.31,15.31,0,0,0,.07,2.45l.42.64s.65,5.71,8.48,6,12.22-3.26,13.85-6.68,2.28-9,3.59-12.22C424.24,262.69,424.4,262.36,424.57,262Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,268.4c-1.32,4.76-.53,6.09-1.85,14.29s-6.08,17.45-7.94,25.92-1,38.36-.79,39.68a12.68,12.68,0,0,1,.12,2.12c.88-.33,1.42-.79,1.46-1.41,1-15.94-1.88-31.52,3.66-47,2.15-6,4.61-12.38,6.44-18.68s2.14-12.85,3.33-19.3c.5-2.7-.29-3.56-1-3.81l0,0A35.18,35.18,0,0,0,420,268.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.29,268.88a68.68,68.68,0,0,0-8.47,4.57c-2.45,1.79-2,6.19-2,7.33s-6.52,11.74-5.38,15.49,3.91,13.69,4.08,16-.33,8.8-.33,8.8H385a142.07,142.07,0,0,1,.82-17.28c1-7.33,3.1-9.94,3.1-21.18s-12.23-13.37-15.32-13.7A50.56,50.56,0,0,0,366.29,268.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,296.27c1,3.39,3.4,11.84,4,15.11,0-1.4,0-2.75-.05-3.87-.16-4.72,0-11.41,4.73-22.33,3.63-8.39,5.72-13.88,6.49-16a61.42,61.42,0,0,0-7.79,4.25c-2.45,1.79-2,6.19-2,7.33S349.34,292.52,350.48,296.27Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.87,319.74s-2.13,3.22-3.63,5.27-3.92,6-2.24,6.17,3.55-1.49,5.42-2.43a7,7,0,0,0,2.8-3.36s-.56,3.55.75,2.8,1.31-3.36,1.31-5.05a39.21,39.21,0,0,1,.37-4.29S328.19,316.7,325.87,319.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.87,323.9s-9.09,0-10.57.85-6.55,24.72-10.77,34.44c0,0-3.38,8.45-6.13,12.47-1,1.41-5.5,3.17-8.67,4s-4.43,1.48-4,2.33,7,2.32,9.93,2.75,4.86-.43,5.71-.43,1.9,1.06,3.59.43.63-5.08.63-7.61,3.17-11.62,6.76-15.43,10.57-18.38,12.05-22.82,1.9-5.49,1.9-5.49",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.68,329a8.82,8.82,0,0,0-5.38,8.45c0,6.54,9.61,48.05,9.61,50.35a13.15,13.15,0,0,1-4.62,10.77c-.69.63-4.7,3.45-4.24,4.75.76,2.14,6.13.06,7.44-.5,2.37-1,5-5.18,7.57-5,2.73.16,3.07-1.15,3.07-3.85s-3-6.07-3.36-9.92-1.61-17.42-.46-23.91c1.06-6-4.25-21.13-4.25-21.13s16.32,10,30.71,6.51-13.42-9.58-17.64-12.66S328.14,326.67,324.68,329Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.68,328.55S326.87,336.37,336,340l3.17-15.42s-13.53-2.33-22.83.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,321a142.07,142.07,0,0,1,.82-17.28c1-7.33,3.1-9.94,3.1-21.18,0-10.47-10.59-13-14.55-13.6a23.66,23.66,0,0,0-2.24,4.79c-.33,1.63-7.34,15.81-9,26.41-1.3,8.47-.21,17.55.28,20.86h-9.24l.43,3.32-17.3-.76L333,340.81s9.32,4,16.06,6.76,20.3,5.34,28.43,2.78c6.7-2.1,11.69-5.72,10.78-13.27A108.26,108.26,0,0,0,385,321Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "365.61 269.2 357.16 281.43 358.14 284.2 355.37 287.3 354.88 296.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "373.46 273.77 372.97 283.55 369.55 285.67 370.85 288.28 364.17 300.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.44,240s-1.93,4.34-1.77,5.63-.15,2.81-1.4,3.3-2.61,1.47-2,2.54A4.57,4.57,0,0,0,356,253s-.82,5.36-.32,6.77,1.49,4.09,3.11,3.89,5.68-.54,5.68-.54a15.48,15.48,0,0,1,.39,8.18c-1,4.73-4.56,9.13-.65,10.1s6.2-4.07,8-7.66,2.74-8.29,3.55-11,2-5.5,2-5.5a11.34,11.34,0,0,1-7.48-7.45c-2.26-6.29-2.13-10.58-5.52-11.47A4.92,4.92,0,0,0,359.44,240Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.4,258.64s.34,2.75,3.43,1.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.1,235.36s-3.48-.23-5.8-.44-3.24,3-2.7,4.77,1.07,2,1.07,2,3.22-1.87,3.54-.6-2.66,3.78-1.09,5.89,4.08,3.76,2.79,5.24-.64,2.87.5,2.73,2.67-2.3,3.29.08-2.27,4.22-1.65,5.3,6.55,2.47,8.21,1.28,5.79-2.35,7.74-9.16,0-11.66-4.1-15.92-11.11-.93-11.11-.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.44,240.83a8.74,8.74,0,0,1,1.81,1.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.25,239.75a19.38,19.38,0,0,1,8.6.43",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.87,319.74l.49-1.14c.49-1.14,5.72-2.11,10.89-2.85,8.37-1.19,12.46-2.53,17.31-3.51,6-1.22,12.38-2.77,12.38-2.77s10.76,2.44,9,6-6.69,4.24-6.69,4.24H328.39A2,2,0,0,1,327,322",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.63,290.07s-2.12,9.46-3.43,11.9-4.07,1.63-3.91,3.1a11.3,11.3,0,0,0,.82,2.93s-2,0-2,.82,2.28,3.75,5.22,5.21,5.05,3.1,6.35,1.47,2.61-4.73,2.45-5.38,1.14.49,2.28-1a4.87,4.87,0,0,0,1-3.75c0-1.3,4.23-11.89,4.72-12.87",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.51,306.85a40.43,40.43,0,0,1,8.22,2.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.05,306.3s3,4.93,7.67,5.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.88,246.68s.32,4.89-3.91,12.55-10.11,22.33-5.87,30.31,15.81,6.36,19.07-.81,1.14-25.43-2.28-33.09S382,245.21,382,245.21,380,244.23,379.88,246.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.44,290.59a6.83,6.83,0,0,0,4.31-1.59",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.75,249.75a73.19,73.19,0,0,1-3,28.5c-1.83,5.58-1.56,9.39.71,11.24",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.25,255.75s-5,12.75-9,21.5-.5,14.25,5.5,15.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.47,321s-.74,8.32.8,9.47,12.68,4.62,20,2.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 354.66,
    y1: 324.36,
    x2: 361.58,
    y2: 325.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.49,402.8c2.37-1,5-5.18,7.57-5,2.73.16,3.07-1.15,3.07-3.85a8.18,8.18,0,0,0-.91-3.19c-.07.12-.14.23-.21.36a13.9,13.9,0,0,1-7.61,6.76,6,6,0,0,1-4.22,0l-.32.13c-.18.19-.37.37-.57.56-.69.63-4.7,3.45-4.24,4.75C320.81,405.44,326.18,403.36,327.49,402.8Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.62,374.77c-1,.36-2,.67-2.89.9-3.17.85-4.43,1.48-4,2.33s7,2.32,9.93,2.75,4.86-.43,5.71-.43,1.9,1.06,3.59.43c1.42-.54.9-3.74.7-6.25a31.78,31.78,0,0,1-6.83,1.39C295.53,376.23,294,375.18,293.62,374.77Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.91,388.76l-.13-.1V370.25h2.64V358.61h-9.79v11.64h2.65V389l-23.41,7.46v1.86a2.12,2.12,0,0,0,4.23,0V398l19.58-2.28v2.81a1.85,1.85,0,1,0,3.7,0v-2.9L401.75,398v.27a2.12,2.12,0,0,0,4.23,0v-1.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 347.25,
    width: 63.5,
    height: 13.5,
    rx: 4,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk2--inject-80"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.75,
    y: 285.55,
    width: 27.46,
    height: 31.72,
    transform: "translate(620.96 602.82) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.34 318.69 295.33 318.69 295.33 290.05 310.01 290.05 326.34 318.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.68,320.29h17.74a1.29,1.29,0,0,0,0-2.57H288.68a3.07,3.07,0,0,1-2.25-1,3,3,0,0,1-.67-2.86l6.29-22.55a1.28,1.28,0,1,0-2.47-.69l-6.3,22.55a5.61,5.61,0,0,0,5.4,7.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.98,
    y: 261.23,
    width: 4.05,
    height: 52.31,
    transform: "translate(624.1 537.49) rotate(173.16)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.88,261.65a78.36,78.36,0,0,0,6.22,51.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.57,
    y: 320.17,
    width: 162.25,
    height: 91.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-80)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.57,
    y: 320.17,
    width: 162.25,
    height: 91.5,
    style: {
      fill: "#fff",
      opacity: 0.72
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 273.57,
    y: 320.17,
    width: 162.25,
    height: 91.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.65,
    y: 322.37,
    width: 162.05,
    height: 2.53,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.03,
    y: 318.67,
    width: 166.97,
    height: 4,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.29,311.05l-2.5,2s-7.12,3.75-8.5,4.87-.37,2.25.38,3.63,4.37,2.87,5.62,2.87,7-2.75,7.88-4.37,1.75-7.38,1.75-7.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,316.67l-.37,3s-5.13,3-4.63,3.88,1,.62,4-.25,5-2.5,5.13-3.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.54,
    y1: 316.05,
    x2: 164.79,
    y2: 321.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.79,
    y1: 317.42,
    x2: 163.42,
    y2: 323.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.67,318.42s.62,3.5,2.12,4.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.17 307.05 170.17 311.55 174.92 312.67 177.04 307.67 171.17 307.05",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,256.36a24.29,24.29,0,0,0,.39,8.81c1.12,3.88,5.87,23.13,6.5,24.5s.5,3.5.12,5.75,1.13,7.63,1.13,8-2.13,1.88-2.25,3.38,2.37,2.5,4.62,2.75,3.75,0,5.13-6.25-2.63-14.63-5.13-24.5-5.87-17.13-6.37-19.13S164.76,254.05,164,256.36Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.17,392.84s2.5,3.33,2,4.33-5.67,2.5-6.67,3.34a11.45,11.45,0,0,1-5.33,3c-3.17.83-10.84,2.16-10,.83s10.33-8.17,10.33-8.17A98.73,98.73,0,0,1,190.17,392.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.54,396.42s-5.61,2-7.41,3.4a22.46,22.46,0,0,1-3.4,2.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.33,382.34l4.84,10.5s-.17.67-3.17,2a18.34,18.34,0,0,1-6.5,1.33l-2.17-7.83Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.17,304.51s-3.84,2.33-4,3.33a19.58,19.58,0,0,0,.66,4.33s-7.83,16.34-10.16,20.5S158,345,161.33,350.17s13.34,29.5,13.34,29.5l-3.34,18.67,8.5,2.17s5.17-14,7-19.17,6.17-18.5,6.84-23.17,1.16-11.33,1.33-11.83,14.67-21.67,16.67-26.5,1.83-15,.83-17.17S177.17,304.51,177.17,304.51Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "187.17 310.17 182.67 312.34 187.5 315.5 180 314.5 187.83 317.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5,312.34,190.33,316s11.5-2.17,16.67-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,318.34s-11.5,25.17-11.5,29.83-1.67,30.34-1.67,30.34",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.74,247.2s-15.37,7.58-15.71,9.16,1.47,6.1,1.47,6.1,9.49,30.87,10.28,33.36,1.13,3.05.34,4.29-1.81,3.51-.68,4.75,8.71,3.51,13.57,3.51,13.57-1.47,19.22-2.83,5.43-3.84,5.2-6.44-3.5-47.15-3.5-48.85-12-4.18-16.06-4.41S181.1,245.84,179.74,247.2Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.4,254.9l3.89,11,6.25-11.15s-1.69-5.4-6.25-5.06S181.4,254.9,181.4,254.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.29,265.88s-2,30.57-2,32.09-1.52,6.42-1.52,6.42l3.38,3.88s5.4-3.88,6.25-6.75S185.29,265.88,185.29,265.88Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.74,246.18s-.79,4.75-.34,6.79-1.47,6.67-.56,7.23,3.95-5.54,3.95-5.54l3.4,5.77,2.26-6.11s3.16,6.22,4.07,5.66-.57-4.41.79-6.33a10,10,0,0,0,1-8c-.8-3.05-4.07-3.05-6.79-2.72S181.66,243.24,179.74,246.18Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.74,247.2s3.62,5,4.3,7.35,1.69,7.35,2.15,5.88.22-7.12,2.94-10.29,2-5.43,2-5.43S187.66,249,179.74,247.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.51,238.16s4.4,8.7,8.93,11,9.27-.11,10.51-3.61.11-8,.11-8,2.49-1.47,2.83-3.39.68-2.6-1.92-4.07a17.08,17.08,0,0,0-3.17-1.59s-.11-3.84-2.37-5.08-7-.57-9.84,2.48S172.51,238.16,172.51,238.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,237.25a16.52,16.52,0,0,1,1.92,3.62c.23,1.13-.68,2.49.68,2.49a3,3,0,0,0,2.15-.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.56,233.82s.57-2,3.21-1.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.21,235.61s-2-.56-3.88,1.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.5,243.37l.76,2.25a5.83,5.83,0,0,0,4.53-4.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.53,239.57a3.11,3.11,0,1,1-3.11-3.11A3.11,3.11,0,0,1,180.53,239.57Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.33,
    y1: 235.33,
    x2: 191.73,
    y2: 232.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.45,236.29a3.11,3.11,0,1,1-3.11-3.11A3.11,3.11,0,0,1,188.45,236.29Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.26,235.94c.16.35.1.73-.14.84s-.56-.1-.72-.46-.1-.73.14-.84S186.1,235.58,186.26,235.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.3,238.73c.16.36.1.74-.14.84s-.56-.09-.72-.45-.1-.73.14-.84S179.14,238.37,179.3,238.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,238.38s1.24-1.58,2.37-.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.89,228s-3.84,4.18-6.78,8a37.59,37.59,0,0,1-3.51,4.29,30.73,30.73,0,0,1-1.81-4,33.4,33.4,0,0,0-1.24-3.17l-1,2.26s-2.94-11,.23-16.05,10.33-6.38,15.76-4.46,6.17,6.95,7.19,9.55,1.92,5.87,1.92,5.87l-1.47,3.17s-2.71-2.37-4.07-3.62a6.79,6.79,0,0,1-1.81-2.94s-2.26,2.72-2.94,3.51a3.5,3.5,0,0,1-1.36,1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.94,217.33a29.22,29.22,0,0,1-7.39,13.41",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.31,218.15a17.34,17.34,0,0,1-1.37,8.49",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,249.15s4.36,1.14,5.88,3.23,11.76,30.92,12.14,35.85-1.14,15.17-.76,16.31,1.52,2.66.38,3.23a15.25,15.25,0,0,0-2.85,2.27,69.19,69.19,0,0,1-7.39-.76c-1.14-.38-2.66-2.84-1.52-4.36a6,6,0,0,0,1.33-3.6c0-.76-2.37-10.09-2.37-12a45.09,45.09,0,0,0-.28-5.2,77.61,77.61,0,0,0-2.46-8.21,35.41,35.41,0,0,1-4.38-18.07",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.44 309.28 216.06 312.89 222.32 313.83 223.83 310.04 216.44 309.28",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.06,312.89s-7.21,3.22-7.78,4.17-1.71,5.5-2.47,6.07-1.51,1.33.57,1.14,2.66-1.33,2.66-1.33a7.55,7.55,0,0,0,0,2.11,40,40,0,0,0,4.71.29,5.42,5.42,0,0,0,1.42,0s-.38.91.33,1.21.67-.38,1.13-1a22.37,22.37,0,0,0,1.41-3.21,8.13,8.13,0,0,0,.5-1.75,12.88,12.88,0,0,0,3.09-2.33c1-1.21.46-4.71.46-4.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.04,
    y1: 322.94,
    x2: 209.42,
    y2: 318.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.92,
    y1: 325.3,
    x2: 211.54,
    y2: 318.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.29,
    y1: 325.17,
    x2: 214.29,
    y2: 318.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.21,325.3s.83-5.38,1-6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.33,398.34s-2.83,2.5-3.33,2.83-9.67,5.34-9.5,6.67,9.67.67,15-.67,5.67-1.83,5.83-2.66.5-4,.5-4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.31,407.23s12.61-.2,17.62-3.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.46,399.94s10.64,2.87,13.18,5.07-5.07,2.87-9.8,2.7-5.23-1.52-8.61-1.52-6.42,1.52-6.93-1.52,3.72-4.22,6.59-4.9A11.7,11.7,0,0,1,103.46,399.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.39,404.83s5.21,3.4,14.42,1.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.82,401.63a58.5,58.5,0,0,0,8.11,4.39c3.72,1.52,6.42,2,4.73,3.38s-2.2,1.52-6.42,2.36-12.67-1.35-13.51-1.35-1.69,1-4,.17-2.7-2-1.86-4.73S91.47,400.78,92.82,401.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.18,408.63a32.52,32.52,0,0,0,19.82.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,284.59l2,21.28s-2.88,30.57-6.42,40.53-6.76,20.94-7.94,25-2.36,19.93-1.35,23.13a13.08,13.08,0,0,1,.84,4.73v.68s.68.51-1.69,1.86a18.72,18.72,0,0,1-5.4,1.85l-3.55-2s-5.06,3.71-6.92,4.73a26.37,26.37,0,0,1-6.08,1.69A8.59,8.59,0,0,1,78.47,404v-6.58c0-2.37-1.69-14-1.52-21.11s1.52-14.87,2.87-18.41,5.91-14.36,5.91-14.36A60.88,60.88,0,0,0,83.53,330c-2.19-8.61-2.7-13-5.57-22.29s2.87-23,2.87-23,13.34,2.36,20.61,2A90.17,90.17,0,0,0,116.3,284.59Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,302.83a27,27,0,0,0,2.53,3.72",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "100.09 289.83 105.66 290 105.49 288.64",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.69,289v1.35s4.72,1.19,8.44-.84",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.09,292l-1.35,5.24,2.19,3s-3.2,5.57-3.2,6.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.1,307.39,108.53,312s-3.38,28.71-5.24,36.14-8.78,31.58-9.62,37a76.6,76.6,0,0,0-1,7.93c0,.51,1,2.37,1,3.38v3.89",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.55,287.63s10.14,1.35,14.7,1,5.23-2.19,5.74-3.88-6.08-41.88-6.42-44.25.17-6.25-3-7.6-10,1-11.15,5.58,2.54,31.07,1.52,36.81A118.59,118.59,0,0,0,97.55,287.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.33 240.85 108.87 245.41 109.71 283.24 112.75 290.5 115.28 281.55 110.39 245.07 111.06 239.67 109.04 235.28 106.33 240.85",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.71 238.99 112.75 244.23 111.23 234.6 108.19 236.46 109.71 238.99",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.28,224.13l-.84,3.88,6.92,12.33s2.07-4.6,2.87-5.74,4-6.15,4-6.15-5.13.41-6-2.63,0-7.26-3.21-7.6S102.28,224.13,102.28,224.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.64,221.74l.33,1.14a3.94,3.94,0,0,0,.46,3.38c1.12,1.43,7.41,4.88,10.16,4.07s3.59-8.79,3.59-8.79,2.63-.06,2.36-1.57-1.8-3.16-2-4.88.77-2.16.37-4.15a7.53,7.53,0,0,0-2.86-5c-1.82-1.4-11.77,3.09-14.72,6.24s-3.56,6.49-2.83,8.39S105.64,221.74,105.64,221.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.36,215.85c0,.62-.27,1.1-.52,1.09s-.41-.53-.37-1.14.27-1.1.52-1.09S118.4,215.24,118.36,215.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.06,213s-1.26-1.16-2.54.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75,224a2.77,2.77,0,0,1-1.54-1.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.87,214.52l-.33,3.09,1.95-.57s-1,2.42.38,1.3,3.33-4.85,3.94-5.2,4-3.64,6.36-5.91,3.36-5.37,2.56-6.9-10.48-8.2-19.32-3.51-11.23,11.55-10.3,15.33,8,13.66,9.31,13.81,4.22-4.22,4.22-4.22-3.81-1-3-2.63S106.87,214.52,106.87,214.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1,215.36a27.88,27.88,0,0,1-3.64,2.19",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.87,199.05a87.26,87.26,0,0,1-12.1,13.42",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,212.84c-.38.35-.77.71-1.18,1.07",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.58,199.47a62.81,62.81,0,0,1-9.21,11.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.1 226.66 109.71 238.99 103.46 245.24 99.07 228.35 101.1 226.66",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.71,229.37l-11.82,3.88s-9.29,44.25-10,45.43-12.83,23-11.31,25.33,16,10.14,17.22,9.63,9.8-16.89,15-21.62S106.33,281.38,107,274.8l-4.56-19.43-.51-12.16Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.09 228.35 96.71 229.37 95.86 245.92 101.61 249.13 98.23 254.19 107.01 274.8 103.46 242.88 100.09 228.35",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.16,299.77,75.67,311.51s1.33,1.6,5.16,2.13C80.83,313.64,86.83,305.44,89.16,299.77Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3,290a59.74,59.74,0,0,1,6.76.5c1.18.34,5.74,5.07,5.74,5.07s0,.51-1.69,1-4.73-1.69-4.73-1.69l-6.58,6.25-4.06-5.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.8 288.14 92.32 290.16 86.74 296.07 86.07 293.88 90.8 288.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,230.72s-15.88,0-17.06,1.35-13.68,39.18-13.68,41.37,21.45,22.3,21.45,22.3l6.08-7.43L79.65,269.22l9.63-20.77",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout3);
export default __webpack_public_path__ + "static/media/about3.1fe57f27d88a9854963e8387fbc4d341.svg";
export { ForwardRef as ReactComponent };